// getProjectTasksQueryKey removed — the project-tasks React Query cache no
// longer exists (task data is collection-backed via taskCollection). The
// ProjectTasksQueryKey type is retained for the query-options generic.
//
// getProjectDetailQueryKey removed — project detail is collection-backed
// (projectCollection); the RQ detail cache no longer exists. Reads/writes go
// through src/collections/project/ (getProjectFromCollection / fetchProjectDetail
// / projectCollection.push). See docs/adr/0003.
export const getProjectSprintsQueryKey = ([, projectId])=>[
        'sprints',
        projectId
    ];
export const getSprintsForProject = ([, projectId])=>[
        'sprints-drpdown',
        projectId[1]
    ];
export const getProjectUsersLiteKey = (projectId)=>{
    var _ref;
    return [
        'project-users-lite',
        `${(_ref = projectId === null || projectId === void 0 ? void 0 : projectId.toString()) !== null && _ref !== void 0 ? _ref : 'all'}`
    ];
};
export const getProjectDependencyMapKey = (projectId)=>[
        'project-dependency-map',
        // `projectId` can be undefined during collection-backed hydration even
        // though callers type it as number; the query may be disabled but the key
        // is still computed, so keep it stable instead of throwing.
        `${projectId !== null && projectId !== void 0 ? projectId : ''}`
    ];
